import React, { useCallback, useState } from 'react';
import { FooterButtons } from '../../ServerEdit.page';
import serverStore from '../../../../../stores/server.store';
import styled from 'styled-components';
import { EuiButton, EuiFieldText, EuiFormRow } from '@elastic/eui';
import { addToast } from '../../../../components/toasts/Toast';

const Styles = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: end;
  grid-gap: 14px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }

  .left {
    text-align: left;
    margin-bottom: 4px;
  }

  .euiFormRow {
    margin: 0;
  }
`;

const EditServerName = ({ server, onSave, successMessage = 'Server name changed' }) => {
    const [serverName, setServerName] = useState(server.name);
    const [isSendingSave, setIsSendingSave] = useState(false);
    const serverId = server._id;

    const handleSubmit = useCallback(async () => {
        if (isSendingSave) {
            return;
        }

        setIsSendingSave(true);
        try {
            if (onSave) {
                await onSave(serverId, serverName);
            } else {
                await serverStore.updateServer(serverId, serverName);
            }
            addToast(successMessage, 'suc');
        } catch (error) {
            addToast(error.message || 'Failed to change server name', 'error');
        } finally {
            setIsSendingSave(false);
        }
    }, [isSendingSave, onSave, serverId, serverName, successMessage]);

    return (
        <Styles>
            <EuiFormRow label="Server Name">
                <EuiFieldText
                    fullWidth={ true }
                    value={ serverName }
                    isInvalid={ false }
                    placeholder="Production API"
                    onChange={ e => setServerName(
                        e.target.value) }
                />
            </EuiFormRow>

            <FooterButtons className={ 'left' }>
                <EuiButton
                    isDisabled={ !serverName }
                    size="s"
                    onClick={ handleSubmit }
                    iconType="save"
                    fill
                    isLoading={ isSendingSave }
                >Save
                </EuiButton>
            </FooterButtons>
        </Styles>
    );
};

export default EditServerName;
